import { render } from "./ExtentionTimePopup.vue?vue&type=template&id=7a9c5c28"
import script from "./ExtentionTimePopup.vue?vue&type=script&lang=js"
export * from "./ExtentionTimePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__